import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGauge, faChartLine, faSackDollar } from '@fortawesome/free-solid-svg-icons';
import DashOverview from './Dashoverview';
import DashAnalytics from './Dashanalytics';
import DashFinance from './Dashfinance';
import './Dashboard.css';

const TABS = [
  { key: 'overview', label: 'This month', icon: faGauge },
  { key: 'analytics', label: 'Activity', icon: faChartLine }, // history charts (the Growth page is Admin › Growth)
  { key: 'finance', label: 'Finance', icon: faSackDollar },
];

const AdminDashboard = ({ userData }) => {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((t) => t.key === params.get('tab')) ? params.get('tab') : 'overview';

  const setTab = (key) => {
    const next = new URLSearchParams(params);
    if (key === 'overview') next.delete('tab');
    else next.set('tab', key);
    setParams(next, { replace: true });
  };

  const firstName = (userData?.firstName || userData?.fullName || '').trim().split(' ')[0];

  return (
    <div className="rmadd">
      <div className="rmadd-inner">
        <header className="rmadd-head">
          <span className="rmadd-eyebrow">Dashboard</span>
          <h1 className="rmadd-title">
            {firstName ? (
              <>
                Welcome back, <span>{firstName}</span>
              </>
            ) : (
              <>
                RoboMind <span>at a glance</span>
              </>
            )}
          </h1>
        </header>

        <div className="rmadd-tabs" role="tablist" aria-label="Dashboard sections">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={tab === t.key}
              className={`rmadd-tab ${tab === t.key ? 'is-on' : ''}`}
              onClick={() => setTab(t.key)}
            >
              <FontAwesomeIcon icon={t.icon} />
              <span>{t.label}</span>
            </button>
          ))}
        </div>

        {/* only the open tab loads its data */}
        <div role="tabpanel" className="rmadd-panel-area">
          {tab === 'overview' && <DashOverview userData={userData} />}
          {tab === 'analytics' && <DashAnalytics userData={userData} />}
          {tab === 'finance' && <DashFinance userData={userData} />}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;